import { useState, useEffect } from 'react';

interface UseTypingAnimationOptions {
  text: string;
  enabled: boolean;
  speed?: number;
}

export const useTypingAnimation = ({ text, enabled, speed = 100 }: UseTypingAnimationOptions) => {
  const [currentText, setCurrentText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    if (!enabled || !text) {
      setCurrentText(text || '');
      setIsTyping(false);
      return;
    }

    setCurrentText('');
    setIsTyping(true);

    let currentIndex = 0;
    
    // Primeira letra imediatamente
    if (text.length > 0) {
      setCurrentText(text[0]);
      currentIndex = 1;
    }
    
    // Se só tem uma letra, parar
    if (text.length === 1) {
      setIsTyping(false);
      return;
    }

    const interval = setInterval(() => {
      if (currentIndex >= text.length) {
        setIsTyping(false);
        clearInterval(interval);
        return;
      }

      const nextChar = text[currentIndex];
      if (nextChar !== undefined) {
        setCurrentText(prev => prev + nextChar);
        currentIndex++;
      } else {
        setIsTyping(false);
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, enabled, speed]);

  return enabled ? currentText : text;
};